import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { DDL } from 'src/app/core-module/models/ddl';
import { CAQuestion } from 'src/app/core-module/models/ExternalAudits/ca-question';

@Component({
    selector: 'app-dropdown',
    templateUrl: './dropdown.component.html',
    styleUrl: './dropdown.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DropdownComponent {
  public SelectedOption: DDL | null = null;
  public showPleaseSelect: boolean = true;

  @Input() currentQuestion: CAQuestion;
  @Output() currentQuestionChange = new EventEmitter<CAQuestion>();

  constructor() {
    this.updateQuestion();
  }
  ngOnChanges() {
    this.updateQuestion();
  }
  updateQuestion() {
    if (this.currentQuestion != undefined) {
      if (this.currentQuestion.AnswerIDs.length > 0) {
        if (this.currentQuestion.QuestionAnswers.findIndex(x => { return x.ID == this.currentQuestion.AnswerIDs[0] }) != -1) {
          this.currentQuestion.QuestionAnswers.forEach(x => { x.SelectedOption = false; });
          this.SelectedOption = this.currentQuestion.QuestionAnswers.find(y => y.ID == this.currentQuestion.AnswerIDs[0])!;
        };
      }
    }
    this.validateAnswer();
  }
  updateNA() {
    this.currentQuestion.NASelected = !this.currentQuestion.NASelected;
    this.validateAnswer();

  }
  validateAnswer() {
    if(this.currentQuestion==undefined){
      return;
    }
    if (this.currentQuestion.AnswerIDs == undefined) {
      if (this.currentQuestion.NASelected) {
        this.currentQuestion.IsAnswered = true;
      } else {
        this.currentQuestion.IsAnswered = false;
      }

      return;
    }
    if (this.currentQuestion.AnswerIDs.length > 0 || this.currentQuestion.NASelected) {
      this.currentQuestion.IsAnswered = true;
      return;
    } else {
      this.currentQuestion.IsAnswered = false;
      return;
    }
  }

  /*ngOnChanges() {
    if(this.currentQuestion.CompletionInfo.Answer!=null){      
      this.SelectedOption = this.currentQuestion.QuestionAnswers.find(e=>Number(e.QuestionAnswerID)==Number(this.currentQuestion.CompletionInfo.Answer))!;
    }else{
      var hasDefault:boolean = false;
      this.currentQuestion.QuestionAnswers.forEach(e=>{if(e.IsDefault){this.SelectedOption = e;hasDefault=true}});
      if(hasDefault){
        this.updateSelected()
      }else{
        if(!this.currentQuestion.QuestionAnswers.some(e=>e.QuestionAnswerID==-1)){
          var newQuestion = new QuestionAnswer({'QuestionAnswerID':-1,'AnswerText':'Please Select...','Selected':true});
          this.currentQuestion.QuestionAnswers.unshift(newQuestion)
        }         
        this.SelectedOption = this.currentQuestion.QuestionAnswers.find(e=>{return e.QuestionAnswerID == -1})!; 
      }

    }   
  }*/

  optionComparison(a: DDL, b: DDL): boolean {
    return a.ID == b.ID;
  }
  updateSelected() {
    this.currentQuestion.AnswerIDs = [];
    this.currentQuestion.QuestionAnswers.forEach(x => {
      if (this.SelectedOption != null) {
        if (x.ID == this.SelectedOption!.ID) {
          x.SelectedOption = true;
          this.currentQuestion.AnswerIDs.push(x.ID);
          this.currentQuestion.IsAnswered = true;
        } else {
          x.SelectedOption = false;
        }
      }
    });
    /*this.currentQuestion.CompletionInfo.Answer = this.SelectedOption.QuestionAnswerID;
    this.currentQuestion.CompletionInfo.QuestionAnswered = true;
    this.currentQuestionChange.emit(this.currentQuestion);*/
  }
}
